import { GetAllJoints, RG_TYPE, deepFlatChildren, getRgObjectsOfType } from "@project-rouge/rg-core";
import { addOpeningOnPivot, getPivot } from "@project-rouge/rg-three";
import { Line3, Vector3 } from "three";
function addDoorsToCores({ building, dataset }) {
	const aggConfig = dataset.aggConfig;
	const rvData = dataset.rvData;
	const doorId = dataset.modulousIds.coreDoorId;
	const joints = GetAllJoints(building.data.anatomy);
	const cores = getRgObjectsOfType(building, RG_TYPE.Core);
	for (const core of cores) {
		const floors = deepFlatChildren(core).filter((c) => c.type === RG_TYPE.Floor);
		const yPivot = (Math.max(...floors.map((f) => f.pos[1] + f.size[1])) + core.anchor[1] * core.size[1]) / core.size[1];
		const doorWidth = rvData.find((d) => d.modulousId === doorId).size[0];
		addCoreDoor({
			core,
			yPivot,
			doorWidth,
			doorId,
			rvData,
			aggConfig,
			joint: !core.data.jointID ? void 0 : joints.find((j) => j.id === core.data.jointID)
		});
	}
}
function addCoreDoor({ core, yPivot, doorWidth, doorId, rvData, aggConfig, joint }) {
	let coreProps = aggConfig.coreWithStairs;
	if (core.data.isCorner) coreProps = aggConfig.cornerCore;
	else if (core.data.hasNonFireLift) coreProps = aggConfig.coreWithLifts;
	else if (core.data.hasFireLift) coreProps = aggConfig.coreWithFfLifts;
	for (const doorPos of coreProps.doorPositions) {
		const pivot = getDoorPivot({
			doorPos,
			core,
			doorWidth,
			y: yPivot,
			joint
		});
		if (!pivot) continue;
		addOpeningOnPivot({
			obj: core,
			modulousId: doorId,
			rvDataList: rvData,
			type: RG_TYPE.Door,
			pivot,
			isEntrance: true
		});
	}
}
var _line = new Line3();
var _doorPos = [new Vector3(), new Vector3()];
function getDoorPivot({ doorPos, core, doorWidth, y, joint }) {
	const pivot = [
		0,
		y,
		0
	];
	pivot[0] = pivotCoordinate(doorPos[0], core.size[0], doorWidth);
	pivot[2] = pivotCoordinate(doorPos[1], core.size[2], doorWidth);
	if (joint) {
		let minDistSq = Infinity;
		const pivotAxis = !doorPos.indexOf(0) ? 0 : 2;
		let closestBone;
		let closestAxisValue = 0;
		const pivotPoints = [0, 1].map((v) => {
			pivot[pivotAxis] = v;
			return getPivot(pivot, core, _doorPos[v]);
		});
		for (const bone of joint.bones) {
			const line = BoneToLine(bone, _line);
			for (let i = 0; i < pivotPoints.length; i++) {
				const point = pivotPoints[i];
				const distSq = distToLineSq(line, point);
				if (minDistSq > distSq) {
					closestBone = bone;
					minDistSq = distSq;
					closestAxisValue = i;
				}
			}
		}
		if (closestBone.floors <= core.data.level) return;
		pivot[pivotAxis] = closestAxisValue;
	}
	return pivot;
}
var _closestPoint = new Vector3();
function distToLineSq(line, point) {
	return line.closestPointToPoint(point, false, _closestPoint).distanceToSquared(point);
}
function BoneToLine(bone, out) {
	out.start.fromArray(bone.joints[0].pos);
	out.end.fromArray(bone.joints[1].pos);
	return out;
}
function pivotCoordinate(pos, coreSize, doorWidth) {
	if (pos >= 0) return (pos + doorWidth * .5) / coreSize;
	return 1 + (pos - doorWidth * .5) / coreSize;
}
export { addDoorsToCores };

//# sourceMappingURL=index34.js.map